import { Dispatch } from "redux";
import { TabItems } from "@hatch-digital-nl/abs-storybook/legacy";
import {
    CertificateExpiryActiveTab,
    setActiveTab,
    setCurrentPage,
} from "../CertificateExpirySlice";

interface Props {
    dispatch: Dispatch;
    activeTab: CertificateExpiryActiveTab;
}

export const tabItems = (props: Props): TabItems[] => {
    const { dispatch, activeTab } = props;

    const onTabClick = (tab: CertificateExpiryActiveTab): void => {
        dispatch(setActiveTab(tab));
        dispatch(setCurrentPage(1));
    };

    return [
        {
            title: "Verloopt binnenkort",
            isActive: activeTab === "expiring_soon",
            onClick: () => onTabClick("expiring_soon"),
        },
        {
            title: "Verlopen",
            isActive: activeTab === "expired",
            onClick: () => onTabClick("expired"),
        },
    ];
};
